import BookingsList from '@website/components/hosts/dashboard/BookingsList';
import AuthenticationLayout, {
  ROLE,
} from '@website/components/layouts/authLayout';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Breadcrumb, Container, Form } from 'react-bootstrap';

// Output page
export default function HostDashboardBookings() {
  const { query } = useRouter();

  const [dateRange, setDateRange] = useState({
    from_date: DateTime.local().toISODate(),
    to_date: '',
  });

  if (!query?.hostURL) return <LoadingPage />;

  return (
    <AuthenticationLayout RequiredRole={ROLE.HOST} isSignInRequired>
      <Container className="pt-3">
        <Breadcrumb className="py-3">
          <Link
            href={`/hosts/dashboard/${query?.hostURL}`}
            legacyBehavior
            passHref
          >
            <Breadcrumb.Item href="">Host Dashboard</Breadcrumb.Item>
          </Link>
          <Breadcrumb.Item active>Bookings</Breadcrumb.Item>
        </Breadcrumb>

        <h1>Bookings</h1>

        <Form className="mb-3">
          <Form.Label htmlFor="from_date">From</Form.Label>
          <Form.Control
            type="date"
            name="from_date"
            value={dateRange.from_date}
            onChange={(e) =>
              setDateRange((prev) => ({ ...prev, from_date: e.target.value }))
            }
          />
          <Form.Label htmlFor="to_date">To</Form.Label>
          <Form.Control
            type="date"
            name="to_date"
            title="To"
            value={dateRange.to_date}
            onChange={(e) =>
              setDateRange((prev) => ({ ...prev, to_date: e.target.value }))
            }
          />
        </Form>

        <BookingsList
          hostURL={query.hostURL as string}
          startDateFilter={dateRange.from_date}
          endDateFilter={dateRange.to_date}
        />
      </Container>
    </AuthenticationLayout>
  );
}
